<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on"> Create Item </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">Create New Item</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="taskItemDetails.task_id"
                  :items="taskMap"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.task_id"
                  :rules="[(v) => !!v || 'You must select a task.']"
                  label="Task*"
                  hint="Select which task the item will belong to. You can create new tasks on the Task page."
                  persistent-hint
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Name*"
                  :rules="[(v) => !!v || 'Name is required.']"
                  v-model="taskItemDetails.name"
                  required
                  hint="Please use snake case (e.g., research_item)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Code*"
                  :rules="[(v) => !!v || 'Item code is required.']"
                  v-model="taskItemDetails.code"
                  required
                  hint="This will be auto-generated in the future."
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :placeholder="version"
                  :rules="[(v) => !!v || 'A starting version is required.']"
                  v-model="taskItemDetails.version"
                  label="Version*"
                  required
                  hint="New items should be created with version 0.1.0."
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Goal"
                  hint="Goal of the item."
                  v-model="taskItemDetails.goal"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Definition"
                  hint="Definition of the item."
                  v-model="taskItemDetails.definition"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Range"
                  hint="The minimum and maximum expected scores (e.g., 0-1)."
                  v-model="taskItemDetails.range"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Phase"
                  hint="Which phase of the task the item will be observed."
                  v-model="taskItemDetails.phase"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
        <v-btn :disabled="!valid" color="primary" text @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Bus } from '@/bus'

export default {
  name: 'CreateItem',
  props: {
    taskMap: Array
  },
  data () {
    return {
      valid: true,
      dialog: false,
      taskItemDetails: {},
      version: '0.1.0'
    }
  },
  methods: {
    save () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        try {
          this.$store.dispatch('bcm/createTaskItem', this.taskItemDetails)
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: `Failed to create Task Item in Blueprint Content Manager`
          })
        } finally {
          this.$emit('taskItemSaved')
          this.taskItemDetails = {}
          this.$refs.form.reset()
          this.dialog = false
        }
      }
    }
  }
}
</script>
